(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Parse ISO strings robustly across browsers (handles " ", "+0530", etc.)
  function parseEnd(iso) {
    if (!iso) return NaN;

    var d = new Date(iso);
    if (!isNaN(d)) return d;

    d = new Date(String(iso).replace(' ', 'T'));
    if (!isNaN(d)) return d;

    // Convert "+HHMM" -> "+HH:MM"
    var m = String(iso).match(/([+-]\d{2})(\d{2})$/);
    if (m) {
      d = new Date(String(iso).replace(/([+-]\d{2})(\d{2})$/, m[1] + ':' + m[2]));
      if (!isNaN(d)) return d;
    }

    try { return new Date(Date.parse(iso)); } catch (e) {}
    return NaN;
  }

  function start(el) {
    if (el.__rpTimer) return; // already bound

    var raw = el.getAttribute('data-promo-end');
    var end = parseEnd(raw);
    if (isNaN(end)) return;

    function update() {
      var now = new Date();
      var diff = Math.max(0, end - now);
      var s = Math.floor(diff / 1000);

      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;

      var eta = el.querySelector('.rp-eta');
      if (eta) {
        var text = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        eta.textContent = text;
      }

      if (diff <= 0) {
        clearInterval(el.__rpTimer);
        el.__rpTimer = null;
      }
    }

    update();
    el.__rpTimer = setInterval(update, 1000);
  }

  function boot() {
    // Support both our class and generic data attribute
    document.querySelectorAll('.rp-countdown,[data-promo-end]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
